import axios from 'axios';
import { getProducersQuery } from './queries';
import { buildExpressQuery, buildLoopbackQuery } from './queries/builders';
import Split from '../split';

const getBulkChartsForProducer = async (id) => {
    try {
        const queryBuilder = Split.getBooleanTreatment('use_express_auth_endpoints') ? buildExpressQuery : buildLoopbackQuery;
        const query = getProducersQuery({ ids: [id], fields: ['id', 'bulk_charts'], queryBuilder });
        const request = axios.get(query);
        const response = await request;
        return response?.data?.[0]?.bulk_charts;
    } catch (err) {
        // eslint-disable-next-line
        console.log(err);
        throw new Error('Unable to process request.');
    }
};

export default getBulkChartsForProducer;
